import React from "react";
import "./Error.css";

function Error() {
  return (
    <div className="error-container">
      {/* Bubble background effect */}
      <div className="error-bubbles">
        <div className="error-bubble"></div>
        <div className="error-bubble"></div>
        <div className="error-bubble"></div>
        <div className="error-bubble"></div>
        <div className="error-bubble"></div>
      </div>
      <div className="error-bg-shape"></div>
      <div className="error-bg-shape2"></div>
      <div className="error-bg-shape3"></div>
      <div className="error-icons">
        <span className="error-icon" role="img" aria-label="compass">
          🧭
        </span>
        <span className="error-icon" role="img" aria-label="rocket">
          🚀
        </span>
        <span className="error-icon" role="img" aria-label="star">
          ⭐
        </span>
      </div>
      <div className="error-content">
        <h1 className="error-title">404</h1>
        <h2 className="error-subtitle">Page Not Found</h2>
        <p className="error-message">
          Oops! The page you're looking for doesn't exist or has been moved or
          temporarily changed.
        </p>
        <a href="/" className="error-home-btn">
          Go Home
        </a>
      </div>
    </div>
  );
}

export default Error;
